import { useNavigate } from 'react-router-dom';
import { useConversations } from '../hooks';
import { ConversationListPage, ConversationDetailPage } from './conversations';

interface ConversationsProps {
  onBack: () => void;
  initialConversationId?: string | null;
}

/**
 * Main conversation component - routes between list and detail views
 */
export default function Conversations({ onBack, initialConversationId }: ConversationsProps) {
  const navigate = useNavigate();
  const {
    conversations,
    loading,
    error,
    createConversation,
    creatingConversation,
    updateConversation,
    refreshConversations,
  } = useConversations();

  // Find the selected conversation from URL param
  const selectedConversation = initialConversationId
    ? conversations.find((c) => c.id === initialConversationId)
    : null;

  const handleCreateConversation = async () => {
    try {
      const newConversation = await createConversation();
      // Navigate to the new conversation
      navigate(`/conversations/${newConversation.id}`);
    } catch (err) {
      console.error('Failed to create conversation:', err);
    }
  };

  const handleUpdateName = async (name: string) => {
    if (!selectedConversation) return;
    await updateConversation(selectedConversation.id, name);
    // Refresh to get updated data
    await refreshConversations();
  };

  // Show detail view if conversation is selected
  if (selectedConversation) {
    return (
      <ConversationDetailPage conversation={selectedConversation} onUpdateName={handleUpdateName} />
    );
  }

  // Show list view
  return (
    <ConversationListPage
      conversations={conversations}
      loading={loading}
      creating={creatingConversation}
      error={error?.message || null}
      onCreateConversation={handleCreateConversation}
      onBack={onBack}
    />
  );
}
